import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';

type Props = {
  target: string;
  body: string;
  onChangedBody: (name: string, value: string) => void;
  fromEntry?: boolean;
};

export const Component: FunctionComponent<Props> = ({
  target,
  body,
  onChangedBody,
  fromEntry,
}) => {
  const [text, setText] = useState(body || '');

  useEffect(() => {
    setText(body || '');
  }, [body]);

  const handleChange = (name: string, value: string) => {
    setText(value);
    onChangedBody(target, value);
  };

  return (
    <Presentation
      target={target}
      text={text}
      handleChange={handleChange}
      fromEntry={fromEntry}
    />
  );
};
